import * as React from 'react';
const RagadiAlSenoIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M87.36 87.35a5.69 5.69 0 0 0-3.64 5.32c0 3.15 2.55 5.7 5.7 5.7 2.36 0 4.39-1.43 5.25-3.48M132.57 91.86a7.09 7.09 0 0 0 6.51 6.63"
      className="prefix__cls-1"
    />
    <path
      d="M57.66 96.74c7.5 12.86 10.28 27.61 8.14 42.34M70.69 98.37c2.59 6.61 8.79 11.07 15.82 11.38s13.59-3.4 16.75-9.75M140.71 88.6c.9 0 1.63.73 1.63 1.63v1.63c0 .9-.73 1.63-1.63 1.63M140.71 93.49a15.13 15.13 0 0 1-10.41 12.31c-5.56 1.77-11.64.2-15.65-4.02M124.43 60.91c.81 10.59 8.02 20.47 16.29 27.69M130.31 105.8c0 16.64-7.51 26.77-7.51 33.29"
      className="prefix__cls-2"
    />
  </svg>
);
export default RagadiAlSenoIcon;
